import { render, staticRenderFns } from "./OnewayDialog.vue?vue&type=template&id=10fee72c&scoped=true&"
import script from "./OnewayDialog.vue?vue&type=script&lang=ts&"
export * from "./OnewayDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OnewayDialog.vue?vue&type=style&index=0&id=10fee72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fee72c",
  null
  
)

export default component.exports